module.exports = __webpack_public_path__ + "static/img/jingyin.c58219f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/jingyin.png
// module id = 7jnP
// module chunks = 24